import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

interface DamnDirectionsModalProps {
    open: boolean;
    toggleOpen: () => void;
    handleMapDirections: () => void;
    body: React.ReactNode;
}

const DamnDirectionsModal: React.FC<DamnDirectionsModalProps> = ({ open, toggleOpen, handleMapDirections, body }) => {
    return (
        <Dialog
            open={open}
            onClose={toggleOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle className="bg-plot-blue text-white" id="alert-dialog-title">
                Delivery Has a Waypoint
            </DialogTitle>
            <DialogContent className="mt-2 flex flex-col gap-4">{body}</DialogContent>
            <DialogActions>
                <Button onClick={toggleOpen}>Close</Button>
                <Button onClick={handleMapDirections} autoFocus>
                    Get Directions
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default DamnDirectionsModal;
